(ns app.front.view.registration.terms-of-service
  (:require [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.i18n :as i18n]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [schema-tools.core :as st]
            [schema.core :as s]))

(rf/reg-event-fx ::fetch
  (fn [_ [_ document-type]]
    {:comm/command {:command    :terms/document
                    :method     :get
                    :data       (p/assoc-if {:doc-type document-type}
                                            :language (some-> (i18n/get-local-locale)
                                                              keyword))
                    :on-success [::fetch.success document-type]}}))

(rf/reg-event-db ::fetch.success
  (fn [db [_ doc-type status resp]]
    (if (= status 200)
      (assoc-in db [::docs doc-type] resp)
      db)))

(rf/reg-sub ::documents
  :-> ::docs)

(rf/reg-sub ::document
  :<- [::documents]
  (fn [docs [_ doc-type]]
    (get docs doc-type)))

(defn loading-spinner []
  (cc/loading-spinner {:class-name   "m-auto"
                       :with-overlay false}))

(defmulti render-section (fn [[tag & _children]] tag))

(defn do-render-section [[tag & children]]
  (render-section (->> children
                       (map (fn [child]
                              (if (vector? child)
                                (do-render-section child)
                                child)))
                       (into [tag]))))

(defmethod render-section :default [[tag & children]]
  (.error js/console "missing ToS renderer" tag)
  (->> children
       (map str)
       (into [:p])))

(defmethod render-section 'h1 [[_ & children]] (into [:h1.mb-8] children))
(defmethod render-section 'h2 [[_ & children]] (into [:h2.mb-4] children))
(defmethod render-section 'h3 [[_ & children]] (into [:h3.mb-4] children))

(defmethod render-section 'ul [[_ & children]]
  (->> children
       (map (fn [txt] (if (string? txt) [:li txt] txt)))
       (into [:ul.list-disc.list-outside.ml-6.mb-4])))

(defmethod render-section :p [[_ & children]] (into [:p] children))
(defmethod render-section :li [content] content)
(defmethod render-section :a [content] content)

(defmethod render-section 'privacy-policy [_]
  (let [location    (.-location js/window)
        privacy-loc (str (.-origin location)
                         (.-pathname location)
                         "?privacy=true")]
    [:a {:href privacy-loc} privacy-loc]))

(defmethod render-section 'b [[_ & children]] (into [:p.font-bold] children))

(defn render-document [document]
  (some->> document
           (map do-render-section)
           (into [:div])))

(defn visible-doc-modal [doc-type]
  (cc/modal
    {:open             true
     :passive-modal    true
     :on-request-close #(>evt [:route/push (<sub [:route/name])])}
    [:div (if-let [doc (<sub [::document doc-type])]
            [render-document doc]
            [loading-spinner])]))

(defn doc-modal [match]
  (let [{:keys [terms privacy]} (get-in match [:parameters :query])]
    (cond
      terms   [visible-doc-modal :terms-of-service]
      privacy [visible-doc-modal :privacy-policy]
      :else   nil)))

(def doc-modal-controller
  "Include route-parameters in the route query parameters to make parsing
  of ToS parameters trigger the correct document fetch. Then include doc-modal
  somewhere on the page"
  [{:parameters {:query [:privacy :terms]}
    :start      (fn [{{:keys [privacy terms]} :query}]
                  (when terms (>evt [::fetch :terms-of-service]))
                  (when privacy (>evt [::fetch :privacy-policy])))}])

(def route-parameters
  (st/optional-keys
    {:terms   s/Bool
     :privacy s/Bool}))
